import type { MouseEventHandler } from 'react';

import classNames from 'classnames';

import style from './Hamburger.module.css';

import { ButtonBase } from '../../../ButtonBase';

export interface HamburgerProps {
  /** Toggle open/closed icon. */
  isOpen?: boolean;
  /** Renders the hamburger in dark or light mode. */
  isDark?: boolean;
  /** Required for accessibility. The id of the menu with the items. */
  menuId: string;

  onClick?: MouseEventHandler<HTMLButtonElement>;
}

/** Render an hamburger button that when is open appears as a close button. */
export function Hamburger(props: HamburgerProps) {
  const barClassName = classNames(style.bar, {
    [style.darkTheme]: props.isDark,
  });
  const className = classNames(style.button, { [style.isOpen]: props.isOpen });
  const label = props.isOpen
    ? 'Close the Navigation Menu'
    : 'Open the Navigation Menu';
  return (
    <ButtonBase
      type="button"
      aria-label={label}
      aria-expanded={props.isOpen}
      aria-controls={props.menuId}
      className={className}
      onClick={props.onClick}
      // We add a `tabIndex` to workaround an issue with the focus trap when menu is open.
      // See https://app.shortcut.com/farmersdog/story/123953
      tabIndex={0}
    >
      <div className={barClassName} />
      <div className={barClassName} />
      <div className={barClassName} />
    </ButtonBase>
  );
}
